import { CommandType } from './Command';

/**
 * スタンスタイプ（3種類）
 */
export enum StanceType {
  /** 通常（攻撃×1.0, 防御×1.0, 特殊×1.0） */
  NORMAL = 'NORMAL',
  /** 攻勢（攻撃×1.125, 防御×0.8, 特殊×1.1） */
  OFFENSIVE = 'OFFENSIVE',
  /** 守勢（攻撃×0.8, 防御×1.125, 特殊×0.8） */
  DEFENSIVE = 'DEFENSIVE',
}

/**
 * スタンス倍率
 */
export interface StanceModifiers {
  /** 攻撃力倍率（武器攻撃の最初のAに適用） */
  attackModifier: number;
  /** 防御力倍率（自身のDに適用） */
  defenseModifier: number;
  /** 特殊攻撃倍率（Spcに適用） */
  specialModifier: number;
}

/**
 * スタンスごとの倍率定義
 */
export const STANCE_MODIFIERS: Record<StanceType, StanceModifiers> = {
  [StanceType.NORMAL]: {
    attackModifier: 1.0,
    defenseModifier: 1.0,
    specialModifier: 1.0,
  },
  [StanceType.OFFENSIVE]: {
    attackModifier: 1.125,
    defenseModifier: 0.8,
    specialModifier: 1.1,
  },
  [StanceType.DEFENSIVE]: {
    attackModifier: 0.8,
    defenseModifier: 1.125,
    specialModifier: 0.8,
  },
};

/**
 * 現在のスタンスとコマンドから次のスタンスを計算
 *
 * スタンス切替ルール:
 * - 現在のスタンスが NORMAL の場合: STANCE_A → OFFENSIVE, STANCE_B → DEFENSIVE
 * - 現在のスタンスが OFFENSIVE の場合: STANCE_A → NORMAL, STANCE_B → DEFENSIVE
 * - 現在のスタンスが DEFENSIVE の場合: STANCE_A → NORMAL, STANCE_B → OFFENSIVE
 *
 * @param current 現在のスタンス
 * @param command スタンス切替コマンド
 * @returns 新しいスタンス
 */
export function calculateNextStance(
  current: StanceType,
  command: CommandType.STANCE_A | CommandType.STANCE_B
): StanceType {
  if (current === StanceType.NORMAL) {
    return command === CommandType.STANCE_A ? StanceType.OFFENSIVE : StanceType.DEFENSIVE;
  }

  if (current === StanceType.OFFENSIVE) {
    return command === CommandType.STANCE_A ? StanceType.NORMAL : StanceType.DEFENSIVE;
  }

  if (current === StanceType.DEFENSIVE) {
    return command === CommandType.STANCE_A ? StanceType.NORMAL : StanceType.OFFENSIVE;
  }

  return current;
}
